module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-99ac98de.png";